import React from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Card,
  CardTitle,
  ContentMaxWidth,
  Muted,
  PageHeading,
  PageSubheading,
  Pill,
  Row,
  Stack,
} from '../../layout/styledComponents'

const sections = [
  { to: '/patient-home/care/medicines', icon: '💊', name: 'Medicines' },
  { to: '/patient-home/care/diet', icon: '🥗', name: 'Diet' },
  { to: '/patient-home/care/activities', icon: '🧘', name: 'Activities' },
  { to: '/patient-home/care/vitals', icon: '❤️', name: 'Vitals' },
  { to: '/patient-home/care/goals', icon: '🎯', name: 'Goals' },
  { to: '/patient-home/assessments', icon: '📋', name: 'Assessments' },
]

export default function CareIndexPage() {
  const navigate = useNavigate()
  return (
    <ContentMaxWidth>
      <Stack $gap="24px">
        <div>
          <Pill>Care plan</Pill>
          <PageHeading style={{ marginTop: 12 }}>Your care plan</PageHeading>
          <PageSubheading>Medicines, diet, activities, vitals, goals and assessments — all in one place.</PageSubheading>
        </div>
        <Stack $gap="12px">
          {sections.map((s) => (
            <Card
              key={s.to}
              as="button"
              onClick={() => navigate(s.to)}
              style={{ textAlign: 'left', cursor: 'pointer', fontFamily: 'inherit' }}
            >
              <Row $between>
                <Row $gap="14px">
                  <span style={{ fontSize: 24 }}>{s.icon}</span>
                  <CardTitle style={{ margin: 0 }}>{s.name}</CardTitle>
                </Row>
                <span aria-hidden style={{ color: '#6B7280', fontSize: 18 }}>›</span>
              </Row>
              <Muted style={{ marginTop: 8 }}>Tap to open.</Muted>
            </Card>
          ))}
        </Stack>
      </Stack>
    </ContentMaxWidth>
  )
}
